import Joi from 'joi';

export const CreateNewLabelValidation = Joi.object({
  name: Joi.string().required().max(20).messages({
    'any.required': 'Please add a label name',
    'string.max': "Label can't be more than 20 characters",
  }),
  selectedColor: Joi.string().required().messages({
    'any.required': 'Please select a color',
  }),
});
